import offers from './models/OffersHelper';
import playlists from './models/PlaylistsHelper';

export default {
  offers,
  playlists,
};
